var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"media-uploader"},[_c('input',{directives:[{name:"show",rawName:"v-show",value:(false),expression:"false"}],ref:'file-input',attrs:{"type":"file","accept":`/${_vm.mediaType}*`,"multiple":!_vm.singleMedia},on:{"change":_vm.initMediaToUpload}})])
}
var staticRenderFns = []

export { render, staticRenderFns }